module.exports = __webpack_public_path__ + "static/logo-fd4a67b5d81b6133420e3f25fdea3e8f.svg";